<template>
  <div>
    <b-card title="Row details support" no-body>
      <div style="padding:20px; justify-content: space-between" class="d-flex">
        <div style="font-weight: 500; font-size: 18px;">
          <feather-icon
            icon="ChevronLeftIcon"
            size="24"
            class=""
            style="cursor: pointer"
            @click="$emit('back', false)"
          />
          {{ getSubject() }}
        </div>
        <div>
          <feather-icon
            icon="FolderIcon"
            size="17"
            class=""
            @click.stop="toggleStarred(email)"
          />
          <feather-icon
            icon="TagIcon"
            size="17"
            class="ml-1"
            @click.stop="toggleStarred(email)"
          />
          <feather-icon
            icon="MailIcon"
            size="17"
            class="ml-1"
            @click.stop="toggleStarred(email)"
          />
          <feather-icon
            icon="Trash2Icon"
            size="17"
            class="ml-1"
            @click.stop="toggleStarred(email)"
          />
        </div>
      </div>

      <div style="background: #f8f8f8">
        <div style="padding: 20px">
          <b-card v-for="(message, index) of getData()" :key="index">
            <div
              class="d-flex pb-2"
              style="justify-content: space-between; border-bottom: 1px solid #EBE9F1;"
            >
              <div class="d-flex">
                <div style="margin-top: 5px">
                  <b-avatar
                    :text="
                      getSender(message)
                        .charAt(0)
                        .toUpperCase()
                    "
                    variant="light-primary"
                  />
                </div>
                <div class="ml-1">
                  <div style="color:#5E5873; font-weight: 500; font-size: 15px">
                    {{ getSender(message) }}
                  </div>
                  <div class="text-muted">{{ getSender(message) }}</div>
                </div>
              </div>
              <div class="font-small-2 text-muted float-right">
                {{ dayjs(message.createdAt).format("DD/MM/YYYY h:mm") }}
              </div>
            </div>
            <div class="mt-2">
              <p class="text-small" style="color: #6e6b7b">
                {{ message.message }}
              </p>
            </div>
          </b-card>
          <b-card>
            <div style="padding: 10px 20px">
              Click here to
              <span class="purple" v-b-modal.reply-message>Reply</span> or
              <span class="purple" v-b-modal.reply-message>Forward</span>
            </div>
          </b-card>
        </div>
      </div>
    </b-card>
    <reply-message-modal
      :messageData="messageData"
      :threadId="threadId"
      @refresh="getMessageThread"
    ></reply-message-modal>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BTable,
  BFormCheckbox,
  BCard,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BImg,
  BFormInput,
  BModal,
  BButton,
  BFormSelect,
  BBadge,
  BPagination,
  BListGroup,
  BListGroupItem,
  BInputGroupPrepend,
  BInputGroup,
} from "bootstrap-vue";
import dayjs from "dayjs";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useApi } from "@core/comp-functions/useApi";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ReplyMessageModal from "../../@core/components/users/modals/ReplyMessageModal.vue";
import { getThread } from "@/service/api.service";

export default {
  components: {
    BTable,
    // BButton,
    BFormCheckbox,
    BFormSelect,
    BFormGroup,
    BFormInput,
    BButton,
    BCard,
    BRow,
    BModal,
    BImg,
    BCol,
    BBadge,
    BAvatar,
    BPagination,
    BListGroup,
    BListGroupItem,
    BInputGroupPrepend,
    BInputGroup,
    ReplyMessageModal,
  },
  data() {
    return {
      response: null,
      userId: null,
      offset: 0,
      limit: 50,
      perPage: 10,
      imageURL: "",
      options: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 15, text: "15" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
      ],
      catoptions: [
        { value: "Standard", text: "Standard" },
        { value: "VIP", text: "VIP" },
        { value: "Charity", text: "Charity" },
      ],
      fields: [
        { key: "fundraiser", label: "Fundraiser" },
        { key: "raisedAmount", label: "Raised" },
        { key: "targetAmount", label: "Target" },
      ],
      status: [
        {
          ABSENT: "light-primary",
          PAID: "light-success",
          PROLIFICFUNDRAISER: "light-danger",
          INITIATED: "light-warning",
          6: "light-info",
        },
      ],
      subjects: {
        1: {
          id: 1,
          description: "Welcome",
        },
        2: {
          id: 2,
          description: "Withdrawal Issue",
        },
        3: {
          id: 3,
          description: "Donation Issue",
        },
        4: {
          id: 4,
          description: "Fundraiser Issue",
        },
        5: {
          id: 5,
          description: "Profile Issue",
        },
        6: {
          id: 6,
          description: "Technical Issue",
        },
        7: {
          id: 7,
          description: "Suggestion",
        },
        8: {
          id: 8,
          description: "Other",
        },
      },
      data: null,
    };
  },
  props: {
    messageData: {
      type: Object,
    },
    threadId: {
      type: String,
    },
  },
  created() {
    this.getMessageThread();
  },
  computed: {
    getEntryNumber() {
      return (
        this.offset + (this.response.data && this.response.data.length ? 1 : 0)
      );
    },
    getEntriesCount() {
      return this.offset + (this.response.data ? this.response.data.length : 0);
    },
  },
  methods: {
    dayjs,
    getDescription(str = "") {
      return str && str.length > 80 ? str.substring(0, 80) + "..." : str;
    },
    getFormattedAmount(amount) {
      return amount.toLocaleString();
    },
    getSubject() {
      const subjectId = Object.keys(this.messageData)[0];
      const subject = this.subjects[`${subjectId}`];
      return subject.description;
    },
    getMessage(message) {
      const obj = Object.values(message)[0];
      return obj.message;
    },
    getSender(message) {
      return message.sender === 2 ? "User" : "Admin";
    },
    getMessageThread() {
      const userId = this.$route.params.userId;
      const obj = Object.values(this.messageData)[0];
      getThread(userId, this.threadId)
        .then((res) => res.json())
        .then((response) => {
          if (response.valid) {
            this.data = response.data;
          } else {
          this.showToast("Error", "danger", response.message);
          }
        })
        .catch((e) => {
          this.showToast("Error", "danger", e);
        });
    },
    getData() {
      if (this.data) {
        return Object.values(Object.values(this.data)[0]);
      }
      return [];
    },
    showToast(title, variant, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          text: text,
          icon: title === "Error" ? "TrashIcon" : "DoneIcon" ,
          variant: variant,
        },
      });
    },
  },
};
</script>

<style scoped>
.file {
  width: 60px;
  border: 2px solid #7367f0;
  border-radius: 2px;
  cursor: pointer;
}

.file-img {
  width: 100%;
  height: 32px;
  border-radius: 2px;
}

.purple {
  color: #7367f0;
}
</style>
